import { useState, useImperativeHandle, FC } from 'react';
import BaseModal from '@/components/BaseModal';
import './index.scss';

interface propsType {
  cRef?: any;
  closeRemined?: any;
}
const SignInClose: FC<propsType> = (props) => {
  const { cRef, closeRemined } = props;
  const [show, setShow] = useState<boolean>(false); //是否展示
  /**
   * @description: 切换弹框状态
   */
  const open = () => {
    setShow(true);
  };
  /**
   * @description: 关闭
   */
  const close = () => {
    setShow(false);
  };
  // 绑定ref
  useImperativeHandle(cRef, () => ({
    open,
    close,
  }));
  return (
    <BaseModal show={show}>
      <div className="signin-close">
        <p className="close__title">
          真的要关闭签到提醒吗？ <br />
          有可能会错过奖励哦
        </p>
        <div className="close__btn">
          <div className="close__btn__not" onClick={close}>
            继续提醒
          </div>
          <div
            className="close__btn__allow"
            onClick={() =>
              closeRemined({
                type: 'close',
                closeMsg: '关闭成功',
                needApi: true,
              })
            }
          >
            确认关闭
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

export default SignInClose;
